// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"170":"css/app","552":"css/pdf","820":"css/registration","993":"css/backoffice"}[chunkId] + ".css";
};